import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { type TQuoteApiCredTypes, tQuoteApi } from '../standards.js'

export type mllrCredType = TQuoteApiCredTypes
export const mllrDocumentTypes = [
  'delivery-photo',
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const mllr: CarrierDef<mllrCredType> = {
  name: 'Roy Miller Freight Lines',
  scac: 'mllr',
  ...tQuoteApi,
  engineLayers: ['rating', 'pickup', 'tracking', 'documents'],
  documentTypes: mllrDocumentTypes,
}
